import { formatNumber } from './formatNumber';

export const getOptionsChart = (
  locales,
  totalCashIn = [],
  totalCashOut = [],
  chartStyles,
  templateName,
) => {
  const { finance, chart } = locales;

  const options = {
    chart: {
      type: 'area',
      toolbar: {
        show: false,
      },
      fontFamily: chartStyles[templateName].fontFamily,
      zoom: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 100],
          colorStops: [],
        },
      },
      selection: {
        enabled: false,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      fontFamily: chartStyles[templateName].fontFamily,
      fontSize: 16,
      itemMargin: {
        vertical: 10,
      },
      labels: {
        colors: chartStyles[templateName].textChartColor,
      },
      markers: {
        height: 4,
        width: 80,
        radius: 8,
      },
    },
    stroke: {
      curve: 'straight',
    },
    grid: {
      borderColor: chartStyles[templateName].borderColor,
      clipMarkers: true,
    },
    dataLabels: {
      textAnchor: 'middle',
      style: {
        fontSize: 12,
        fontFamily: chartStyles[templateName].fontFamily,
        fontWeight: 'bold',
      },
      background: {
        enabled: false,
      },
      offsetY: -10,
      formatter(value) {
        return formatNumber(value);
      },
    },

    markers: {
      strokeColors: chartStyles[templateName].colors,
      size: 3,
    },

    series: [
      {
        name: finance.chart.totalCashIn,
        data: totalCashIn,
      },
      {
        name: finance.chart.totalCashOut,
        data: totalCashOut,
      },
    ],

    colors: chartStyles[templateName].colors,

    xaxis: {
      categories: chart,
      labels: {
        style: { colors: chartStyles[templateName].textChartColor },
      },
    },
    yaxis: {
      labels: {
        style: { colors: chartStyles[templateName].textChartColor },
        formatter(value) {
          return formatNumber(value);
        },
      },
    },
    tooltip: {
      theme: chartStyles[templateName].themeStyle,
      y: {
        formatter(value) {
          return value.toLocaleString(); // needed to force the formatter to show the full number
        },
      },
    },
  };
  return options;
};
